import { get } from 'lodash'
import { set } from 'vue-analytics'

import { CAN_ACCESS } from '@/src/constant'

import getUserIP from './getUserIP'

//ds toan bo quyen
let PERMISSION = [
  'access:admin',
  'access:editor',
  'access:customer',
  'user-management',
  'dashboard',
  'log-management',
  'backup-management',
  'workspace-management',
  'style-management',
  'key-management',
  'basemap-management',
  'raster-type-management',
  'raster-source-management',
]
const ROLE_PERMISSION = {
  'access:editor': [
    'access:editor',
    'workspace-management',
    'style-management',
    'user-management',
    'raster-type-management',
    'raster-source-management',
  ],
  'access:admin': [
    'access:admin',
    'user-management',
    'dashboard',
    'log-management',
    'backup-management',
    'workspace-management',
    'style-management',
    'key-management',
    'basemap-management',
    'raster-type-management',
    'raster-source-management',
    'log-file-errors-management',
    'system-summary',
  ],
  'access:customer': ['access:customer', 'workspace-view'],
}
export class User {
  /**
   *
   * @param {Object} options
   * @param {Number} options.id
   * @param {String} [options.name]
   * @param {String} options.first_name
   * @param {String} options.last_name
   * @param {String} options.email
   * @param {String} [options.created_at]
   * @param {String} [options.updated_at]
   * @param {String} [options.avatar_url]
   * @param {Number} [options.company_id]
   * @param {Object} [options.company]
   * @param {Array.<id: String, name: String, all: Boolean>} options.roles
   */
  constructor(options) {
    const data = options || {}
    this.id = data.id
    this.name = data.name || ''
    this.first_name = data.first_name || ''
    this.last_name = data.last_name || ''

    if (!data.email) {
      getUserIP((ip) => {
        this.email = ip
        set('userId', this.email)
      })
    } else {
      this.email = data.email
      set('userId', this.email)
    }

    this.created_at = data.created_at
    this.center_point = data.center_point
    this.updated_at = data.updated_at
    this.username = data.username
    this.avatar_url = data.avatar_url
    this.birthday = data.birthday
    this.gender = +data.gender
    this.mobile = data.mobile
    this.roles = data.roles || []
    this.primary_role = data.primary_role
  }
  get isLogin() {
    return !!this.id
  }
  setPrimaryRole(value, field = 'code') {
    this.primary_role = this.roles.find((role) => role[field] === value)
    return this
  }
  get primaryRole() {
    return this.primary_role || this.roles[0]
  }

  get permissions() {
    let roles = this.roles
    if (this.primaryRole) {
      roles = [this.primaryRole]
    }
    return roles.reduce(
      (permissions, role) =>
        permissions.concat(
          (ROLE_PERMISSION[role.code] || []).map((x) => ({ name: x }))
        ),
      []
    )
  }

  get isAdmin() {
    for (const role of this.roles) {
      if (role.all) return true
    }

    return false
  }
  get isSysAdmin() {
    return this.hasPermission('access:admin')
  }

  /**
   * Update user properties
   * @param {Object} data
   */
  update(data) {
    const keys = Object.keys(data)
    keys.forEach((key) => {
      this[key] = data[key]

      if (key === 'last_name' || key === 'first_name') {
        this.name = this.first_name + ' ' + this.last_name
        this.full_name = this.name
      } else if (key === 'email') {
        if (!data[key]) {
          getUserIP((ip) => {
            this.email = ip

            set('userId', this.email)
          })
        } else {
          set('userId', this.email)
        }
      }
    })
  }

  // #region Roles, Permissions System

  /**
   * Determine user has a role
   * @param {String} role
   */
  hasRole(role) {
    if (this.isAdmin) return true

    let valid = false

    for (const r of this.roles) {
      if (r.code === role) {
        valid = true
        break
      }
    }

    return valid
  }

  /**
   * Determine user has one in the roles
   * @param {String[]} roles
   */
  hasRoles(roles) {
    if (this.isAdmin) return true

    let valid = false

    for (const role of roles) {
      if (this.hasRole(role)) {
        valid = true
        break
      }
    }

    return valid
  }

  /**
   * Determine user has all the roles
   * @param {String[]} roles
   */
  hasAllRoles(roles) {
    if (this.isAdmin) return true

    if (roles.length === 0) return false

    let valid = true

    for (const role of roles) {
      if (!this.hasRole(role)) {
        valid = false
        break
      }
    }

    return valid
  }

  /**
   * Determine user has a permission
   * @param {String} permission
   */
  hasPermission(permission) {
    if (this.isAdmin) return true

    let valid = false

    for (const p of this.permissions) {
      if (p.name === permission) {
        valid = true
        break
      }
    }
    return valid
  }

  /**
   * Determine user has one in the permissions
   * @param {String[]} permissions
   */
  hasPermissions(permissions) {
    if (this.isAdmin) return true

    let valid = false

    for (const permission of permissions) {
      if (this.hasPermission(permission)) {
        valid = true
        break
      }
    }
    return valid
  }

  /**
   * Determine user has all the permissions
   * @param {String[]} permissions
   */
  hasAllPermissions(permissions = []) {
    if (this.isAdmin) return true

    if (permissions.length === 0) return false

    let valid = true

    for (const permission of permissions) {
      if (!this.hasPermission(permission)) {
        valid = false
        break
      }
    }
    return valid
  }
  // #endregion
  getHomeRoute() {
    if (this.primaryRole.code == 'access:customer')
      return { name: 'workspaces' }
    if (this.primaryRole.code == 'access:admin') return { name: 'dashboard' }
    return { name: 'map' }
  }
  canAccess(permission, data) {
    let access = get(CAN_ACCESS, permission, () => false)
    return access(data, this)
  }
}
